import React from 'react';
import { DatePicker, Menu, Row, Col, Dropdown, Button } from 'antd';
import moment from 'moment-timezone';
import { DownOutlined, CalendarOutlined } from '@ant-design/icons';
import { getTimezoneAwareRanges } from '../hooks/ByDateFilter';
const { RangePicker } = DatePicker;

const DatePickerField = ({
  defaultPickerValue = [],
  defaultValue = [],
  value = [],
  dropDownValue = 'Custom',
  setDropDownValue = () => {},
  setCustomDateRange = () => {},
  setDateChanged = () => {},
  has6MonDisables = true,
  showDropdown = true, //show dropdown or not
  allTimeDateRange = ['2020-01-01', moment().format('YYYY-MM-DD')],
  disabled = false,
  timezone = 'UTC',
}) => {
  // Get timezone-aware ranges
  const ranges = getTimezoneAwareRanges(timezone);
  /**
   * 6 months lookback only
   */
  const getDateValue = (dateVal) => {
    if (!dateVal) return timezone === 'UTC' ? moment.utc() : moment.tz(timezone);
    if (moment.isMoment(dateVal)) return dateVal;
    return timezone === 'UTC' ? moment.utc(dateVal) : moment.tz(dateVal, timezone);
  };

  const start = getDateValue(value[0]);
  const end = getDateValue(value[1]);

  const now = () => timezone === 'UTC' ? moment.utc() : moment.tz(timezone);

  const disabledDates = (current) => {
    if (!current) return false;

    if (has6MonDisables) {
      return current.isBefore(now().subtract(6, 'months')) || current.isAfter(now());
    }
    return current.isAfter(now());
  };

  const onHandleDropdown = (e) => {
    setDropDownValue(e.key);
    const dates = e.key === 'All Time' ? allTimeDateRange : ranges[e.key];
    const startDate = timezone === 'UTC' ? moment.utc(dates[0]) : moment.tz(dates[0], timezone);
    const endDate = timezone === 'UTC' ? moment.utc(dates[1]) : moment.tz(dates[1], timezone);
    setCustomDateRange([startDate, endDate]);
    setDateChanged(true);
  };

  const menuItems = Object.entries(ranges).map(([key]) => (
    <Menu.Item key={key} icon={<CalendarOutlined />}>
      {key}
    </Menu.Item>
  ));

  return (
    <Row justify={'center'} gutter={[8, 8]}>
      <Col xs={24} md={showDropdown ? 15 : 24} lg={showDropdown ? 15 : 24}>
        <RangePicker
          disabled={disabled}
          popupClassName="chart-date-picker-dropdown"
          style={{
            marginBottom: '0.4rem',
            width: '100%',
            minWidth: 0,
          }}
          allowClear={false}
          disabledDate={disabledDates}
          value={[start, end]}
          onCalendarChange={(dates) => {
            if (!dates) return;
            const [newStart, newEnd] = dates;

            if (newStart && newEnd) {
              setCustomDateRange([newStart, newEnd]);
              setDropDownValue('Custom');
              setDateChanged(true);
            }
          }}
        />
      </Col>
      {showDropdown && (
        <Col xs={24} md={9}>
          <Dropdown
            overlay={<Menu onClick={onHandleDropdown}>{menuItems}</Menu>}
            disabled={disabled}
          >
            <Button style={{ width: '100%' }}>
              <CalendarOutlined />
              {dropDownValue} <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
      )}
    </Row>
  );
};

export default DatePickerField;
